function getSVGData(svgUrl, insertInto) {

  async function getData (svgUrl) {

    let data;

    try {
      const response = await fetch(svgUrl);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }
  
      data = response.text();
  
      return data;
  
    } catch (error) {

      console.error(error.message);

    }

  }

  getData(svgUrl).then( value => ( function () {
    
    let logoElement = value;

    insertInto.insertAdjacentHTML( "afterbegin", logoElement );

  })() );


}